import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  /** See if localStorage is supported on platform */
  localStorageSupported: boolean;

  constructor() {
    this.localStorageSupported = typeof window['localStorage'] != "undefined" && window['localStorage'] != null;
  }

  /**
   * Gets one item from localStorage
   *
   * @param key
   */
  get<T = string>(key: string): T {
    if (this.localStorageSupported) {
      const item = localStorage.getItem(key);
      return JSON.parse(item) as T;
    } else {
      return null;
    }
  }

  /**
   * Sets value to localstorage
   *
   * @param key - localStorage key
   * @param item
   */
  set<T = string>(key: string, item: T) {
    if (this.localStorageSupported) {
      try {
        localStorage.setItem(key, JSON.stringify(item));
      } catch(e) {
        if (e.code == 22) {
          console.warn('localStorage quota exceeded!');
        } else {
          console.error(e);
        }
      }
    }
  }

  /**
   * Removes localstorage  by key
   *
   * @param key
   */
  remove(key: string) {
    if (this.localStorageSupported) {
      localStorage.removeItem(key);
    }
  }
}

const storageService = new StorageService();

/**
 * Decorator for localstorage
 *
 * @param key - key to use on db
 * @param Obj - object to instance data `new Obj(data)`
 */
export function LocalStorage(key ?: string, Obj?: { new(data: any): any }) {
  return function(target : Object, propName : string) {
    let propNameId : string  = (key) ? key : propName;

    function getValue() : any {
      const data = storageService.get(propNameId);
      return Obj ? (Array.isArray(data) ? data.map(d => new Obj(d)) : new Obj(data)) : data;
    }

    function setValue(val : any) {
      storageService.set(propNameId, val);
    }

    Object.defineProperty(target, propName, {
      configurable : true,
      enumerable   : true,
      get          : getValue,
      set          : setValue
    });
  }
}
